<template>
  <div>
    <b-table small ref="table" :busy="isBusy" striped hover responsive="true"
      :items="users"
      :fields="fields"
      :per-page="perPage"
      selectable
      @row-selected="onRowSelected"
      select-mode="single"
      caption-top
      @sort-changed="sortingChanged">
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t('Loading...') }}</strong>
      </div>
      <template v-slot:cell(actions)="row">
        <i @click.stop="ClickOnPromisedPaymentButton(row)" class="info fa fa-money-check fa-lg"/>
        <i @click.stop="ClickOnPaymentButton(row)" class="info fa fa-money-bill fa-lg"/>
        <i @click.stop="ClickOnDocumentButton(row)" class="primary fa fa-file-export fa-lg"/>
        <i @click.stop="ClickOnDeleteUserButton(row)" class="danger fa fa-trash-alt fa-lg"/>
      </template>
      <template slot="row-details" slot-scope="row">
        <div style="margin:1px">
          <Detail ref="Detail" :currentRow="row.item" @makeToasts="makeToasts" @refreshTable="refreshTable" @refreshRow="refreshRow"/>
        </div>
      </template>
    </b-table>

    <b-modal ref="modalPromisedPaymentValue" hide-footer :title="$t('Promised payment')" v-if="currentRow">
        <b-form-group :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="promisedPaymentValue" id="popover"/>
        </b-form-group>
        <b-popover target="popover" triggers="hover" placement="top">
          <template v-slot:title/>
          {{ $t('Possible value from 0 to') }} {{ this.maxValue }}
        </b-popover>
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-payment-settings variant="outline-sucess">{{ $t('OtherSettings') }}</b-button>
        </b-card-header>
        <b-collapse id="accordion-payment-settings" accordion="accordion-payment-settings" role="tabpanel">
          <b-card-body>
            <b-form-group :label="$t('Max payment')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled >
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.max_value"/>
            </b-form-group>
            <b-form-group :label="$t('Expires in (days)')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.max_duration"/>
            </b-form-group>
            <b-form-group :label="$t('Interval between uses (days)')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.interval_duration"/>
            </b-form-group>
            <b-form-group :label="$t('Min balance')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.min_balance"/>
            </b-form-group>
            <b-form-group :label="$t('Free if balance over')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.once_service_cost"/>
            </b-form-group>
          </b-card-body>
        </b-collapse>
      </b-card>

      <modal-ok-cancel @save="makePromisedPayment()" @cancel="hideModal()" size="md"/>
    </b-modal>

    <b-modal ref="fileTypeChoice" hide-footer :title="$t('Choose filename')">
        <b-form-group :label="$t('Enter filename')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
          <b-form-input v-model="fileName" :placeholder="$t('Enter filename')"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
          <b-form-select v-model="selectedFileType" :options="options" class="mb-3"/>
        </b-form-group>

      <modal-ok-cancel @save="downloadDocument(currentRow)" @cancel="hideModal()" size="md"/>
    </b-modal>
  </div>
</template>

<script>
import download from '@/utils/downloadFile'
import Detail from '@/pages/users/usersAndGroups/detail/main'

export default {
  props: {
    filter: {
      type: String
    },
    perPage: {
      type: Number
    },
    currentPage: {
      type: Number
    },
    excludeShortSearchFields: [],
    curCustomers: 0
  },
  components: {
    Detail
  },
  data () {
    return {
      maxValue: 0,
      users: [],
      fieldName: new Map([
        ['user_id', 0],
        ['login', 1],
        ['basic_account', 2],
        ['full_name', 3],
        ['email', 4],
        ['balance', 5]]),
      fields: [
        { key: 'user_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'login', label: this.$i18n.t('Login'), sortable: true },
        { key: 'basic_account', label: this.$i18n.t('Basic account'), sortable: true },
        { key: 'full_name', label: this.$i18n.t('FullName'), sortable: true },
        { key: 'email', label: this.$i18n.t('Email') },
        { key: 'telephones', label: this.$i18n.t('Telephones') },
        { key: 'balance', label: this.$i18n.t('Balance'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      options: [
        { value: 0, text: 'odt' },
        { value: 1, text: 'pdf' }
      ],
      currentRow: null,
      curPage: 1,
      localCurFilter: '',
      selectedFileType: 1,
      fileName: '',
      promisedPaymentOtherSettings: {
        'interval_duration': 0,
        'max_duration': 0,
        'max_value': 0,
        'once_service_cost': 0,
        'min_balance': 0
      },
      promisedPaymentText: '',
      promisedPaymentValue: 0,
      isBusy: true,
      selected: []
    }
  },
  methods: {
    sortingChanged (ctx) {
      this.$emit('sortingChanged', ctx)
    },
    onRowSelected (items) {
      for (let i in this.selected) {
        for (let j in items) {
          if (this.selected[i] === items[j]) {
            break
          }
        }
        this.selected[i]._showDetails = false
      }
      this.selected = items
      for (let i in this.selected) {
        this.selected[i]._showDetails = true
      }
    },
    makePromisedPayment () {
      let promisedPayment = {
        account_id: this.currentRow.item.basic_account,
        user_id: this.currentRow.item.user_id,
        value: parseFloat(this.promisedPaymentValue)
      }
      let response = this.$store.dispatch('Tariffing/CREATE_PROMISED_PAYMENT', promisedPayment)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.hideModal()
          this.load()
        }
      })
    },
    async ClickOnPromisedPaymentButton (row) {
      this.currentRow = row
      let payload = {
        user_id: row.item.user_id,
        account_id: row.item.basic_account
      }
      this.$store.dispatch('Tariffing/GET_PROMISED_PAYMENT', payload).then(response => {
        let promisedPaymentSettings = this.$store.getters['Tariffing/PROMISED_PAYMENT']
        if (promisedPaymentSettings.error) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Promised payment settings not found for this user'), 'Error')
          this.hideModal()
        } else {
          if (Number(promisedPaymentSettings.is_possible) === 1) {
            this.promisedPaymentOtherSettings = promisedPaymentSettings
            this.maxValue = this.promisedPaymentOtherSettings.max_value
            this.promisedPaymentOtherSettings.max_duration = this.promisedPaymentOtherSettings.max_duration / 86400
            if (this.promisedPaymentOtherSettings.interval_duration > 0) {
              this.promisedPaymentOtherSettings.interval_duration = this.promisedPaymentOtherSettings.interval_duration / 86400
            }
            this.promisedPaymentValue = promisedPaymentSettings.max_value
            this.$refs.modalPromisedPaymentValue.show()
          } else {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Promised payment not avaible for this user'), 'Error')
            this.hideModal()
          }
        }
      })
    },
    ClickOnDeleteUserButton (item) {
      this.currentRow = item
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to archive one of "Customer"?'), this.deleteUser, item)
    },
    async deleteUser (user) {
      let response = this.$store.dispatch('Users/DELETE_USERS', user.item.user_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.load()
          this.$root.$emit('makeToasts')
        }
      })
    },
    ClickOnPaymentButton (row) {
      this.$emit('ClickOnPaymentButton', row.item)
    },
    ClickOnDocumentButton (row) {
      this.currentRow = row
      this.fileName = row.item.login + '_doc'
      this.$refs.fileTypeChoice.show()
    },
    hideModal () {
      this.$refs.fileTypeChoice.hide()
      this.$refs.modalPromisedPaymentValue.hide()
    },
    downloadDocument (row) {
      this.hideModal()
      if (this.selectedFileType === 0) {
        this.fileName += '.odt'
      } else {
        this.fileName += '.pdf'
      }
      let payload = {
        file_type: this.selectedFileType,
        user_id: row.item.user_id,
        base_id: row.item.user_id
      }
      let response = this.$store.dispatch('Users/GET_DOCUMENT_USER', payload)
      response.then(response => {
        download(response.data, this.fileName, 'application/pdf')
      })
    },
    getCardUsers () {
      let copy = []
      for (let el of JSON.parse(JSON.stringify(this.$store.getters['Users/USERS_LIST'].users))) {
        for (let elUsers of JSON.parse(JSON.stringify(this.$store.getters['Users/USERS'].users))) {
          if (elUsers.login === el.login) {
            el.pass = elUsers.password
            el.accounts = elUsers.accounts
          }
        }
        el.allBalance = 0
        switch (el.block_type_to_flags) {
          case 0:
            el.block = this.$i18n.t('No')
            break
          case 16:
            el.block = this.$i18n.t('System blocking')
            break
          case 256:
            el.block = this.$i18n.t('Admin blocking')
            break
          case 1:
            el.block = this.$i18n.t('User blocking')
            break
        }
        el.balance = Number.parseFloat(el.balance).toFixed(2)
        copy.push(el)
      }
      return copy
    },
    load (newFilter = '', sortingData = null) {
      sortingData = !sortingData ? {sortBy: 'user_id', sortDesc: true} : sortingData
      for (let i in this.selected) {
        this.selected[i]._showDetails = false
      }
      this.selected = []
      let curFilter = newFilter || this.filter
      this.isBusy = true
      let payload = {value: curFilter,
        page: this.curPage,
        per_page: this.perPage,
        sort_field: sortingData.sortBy,
        is_desc: sortingData.sortDesc,
        exclude_fields: [] }
      if (this.excludeShortSearchFields) {
        for (let el of this.excludeShortSearchFields) {
          if (el.is_selected) {
            payload.exclude_fields.push(el.value)
          }
        }
      }
      this.$store.dispatch('Users/USERS_SEARCH',
        payload
      ).then(response => {
        var users = this.$store.getters['Users/USERS'].users
        users = users.filter((value) => {
          return value.card_user === this.curCustomers
        })
        for (var i in users) {
          this.prepareUser(users[i])
        }

        if (this.curCustomers) {
          let stop = this.curPage * this.perPage
          let start = stop - this.perPage < 0 ? 0 : stop - this.perPage
          stop = stop > this.getCardUsers().length ? this.getCardUsers().length : stop
          users = this.getCardUsers().slice(start, stop + 1)
        }

        this.users = users
        this.$emit('input', this.users.length)
        this.isBusy = false
      })
    },
    loadExtSearch (queries, sortingData = null) {
      sortingData = !sortingData ? {sortBy: 'user_id', sortDesc: true} : sortingData
      for (let i in this.selected) {
        this.selected[i]._showDetails = false
      }
      queries.sort_field = sortingData.sortBy
      queries.is_desc = sortingData.sortDesc
      this.selected = []
      this.isBusy = true
      this.$store.dispatch('Users/GET_USERS_EXTENDED_SEARCH', queries).then(response => {
        var users = this.$store.getters['Users/USERS_EXTENDED_SEARCH'].users
        users = users.filter((value) => {
          return value.card_user === this.curCustomers
        })
        for (var i in users) {
          this.prepareUser(users[i])
        }

        this.users = users
        this.$emit('input', this.users.length)
        this.isBusy = false
      })
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    showModalDelete () {
      this.$emit('showModalDelete')
    },
    setPerPage (newVal) {
      this.perPage = newVal
    },
    pageChanged (filter = '',
      pageNum,
      sortingData,
      isCommonSearch = true,
      extQueries = null) {
      this.filter = filter
      this.curPage = pageNum
      if (isCommonSearch) {
        this.load(filter, sortingData)
      } else {
        extQueries.page = pageNum
        extQueries.per_page = this.perPage
        this.loadExtSearch(extQueries, sortingData)
      }
    },
    refreshTable (filter = '') {
      this.curPage = 1
      this.filter = filter
      this.load(filter)
    },
    prepareUser (user) {
      if (!user.is_active_block) {
        user._cellVariants = {user_id: 'success'}
      }
      user.balance = Number.parseFloat(user.balance).toFixed(2)
      user._showDetails = false
    },
    async refreshRow (id, showDetails) {
      this.$store.dispatch('Users/GET_USER', id).then(response => {
        let user = this.$store.getters['Users/USER']
        this.prepareUser(user)
        for (let i in this.users) {
          if (this.users[i].user_id === user.user_id) {
            this.users[i] = user
            break
          }
        }
        this.$refs.table.refresh()
        user._showDetails = showDetails
      })
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    curCustomers () {
      this.load()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/users/Users.vue